import React, { useEffect, useCallback } from 'react';

const IFrame = ({ title, url, class: className, height = 300 }) => {
    const handleIframeTask = useCallback(() => {
        const messageHandler = (event) => {
            if (event.origin === 'https://hd.23byt.es') {
                window.location.reload();
            }
        };

        window.addEventListener('message', messageHandler);
        
        return () => {
            window.removeEventListener('message', messageHandler);
        };
    }, []);

    useEffect(() => {
        handleIframeTask();
    }, [handleIframeTask]);

    return (
        <div className="widget ui-draggable ui-resizable configure-directories">
            <div className="widget-head">
                <h3>
                    <a data-original-title title="true">{title}</a>
                </h3>
            </div>

            <div className="widget-content">
                <iframe 
                    style={{ height }}
                    className={`w-full${className ? ` ${className}` : ''}`} 
                    id="filterFrame" 
                    src={url} 
                    title={title}
                />
            </div>
            <div className="widget-foot">
                &nbsp;
            </div>
        </div>
    );
};

export default IFrame;